module.exports = __webpack_public_path__ + "static/media/avc_waist.602f5921.svg";